<template>
  <div class="xv_view" id="Hospital_view_G">
    <div class="xv_top">
      <div>
        <label class="xv_view_title">{{ this.name }}</label>
      </div>
      <div class="xv_actions">
        <span>Status :</span>
        <!-- <span class="main_status_1">Ok</span> -->
        <span class="main_status_2">Closed</span>
      </div>
    </div>
    <div class="xv_tabs">
      <div>
        <b-tabs content-class="mt-3">
          <b-tab title="Main" active>
            <div class="tab_profile">
              <div class="row">
                <div class="col-7">
                  <div class="pro_section">
                    <label>Name</label>
                    <input type="text" value="American" :disabled="profile_edit == false" />
                  </div>
                  <div class="pro_section">
                    <label>Address</label>
                    <input type="text" value="11 Hougang" :disabled="profile_edit == false" />
                  </div>
                  <div class="pro_section row">
                    <div class="col-6">
                      <label>State</label>
                      <input type="text" value="Hougang" :disabled="profile_edit == false" />
                    </div>
                    <div class="col-6">
                      <label>City</label>
                      <input type="text" value="Hougang" :disabled="profile_edit == false" />
                    </div>
                  </div>
                  <div class="pro_section row">
                    <div class="col-6">
                      <label>Pin</label>
                      <input type="text" value="538789" :disabled="profile_edit == false" />
                    </div>
                    <div class="col-6">
                      <label>Country</label>
                      <input type="text" value="Singapore" :disabled="profile_edit == false" />
                    </div>
                  </div>

                  <div class="pro_section">
                    <label>GPS Location</label>
                    <input
                      type="text"
                      value="40.741895, -73.989308"
                      :disabled="profile_edit == false"
                    />
                  </div>
                  <div class="pro_section">
                    <label>Contact number</label>
                    <input type="text" value="+65 76544356" :disabled="profile_edit == false" />
                  </div>
                  <div class="pro_section">
                    <label>Admin</label>

                    <select name id :disabled="profile_edit == false">
                      <option value="1">Jasmine Morgan</option>
                      <option value="1" selected>Joseph Davis</option>
                      <option value="1">Haleema Andrews</option>
                      <option value="1">Yasmine Hoffman</option>
                      <option value="1">Anthony Cook</option>
                    </select>
                  </div>

                  <div class="row pro_section">
                    <div class="col-4">
                      <label>Status</label>
                      <select name id :disabled="profile_edit == false">
                        <option value="1">Ok</option>
                        <option value="2" selected>Closed</option>
                      </select>
                    </div>
                    <div class="col-4">
                      <label>Till when</label>
                      <input type="text" :disabled="profile_edit == false" />
                    </div>
                    <div class="col-4">
                      <label>Comments</label>
                      <input type="text" :disabled="profile_edit == false" />
                    </div>
                  </div>
                </div>

                <div class="col-5 text-right">
                  <div v-if="profile_edit == false">
                    <button class="pro_btn m_r sec_btn" @click="profile_edit = true">
                      <span class="mdi mdi-pencil"></span>
                    </button>
                    <button class="pro_btn sec_btn" @click="delete_popup()">
                      <span class="mdi mdi-trash-can"></span>
                    </button>
                  </div>

                  <div v-if="profile_edit == true">
                    <button class="pro_btn m_r save save_btn" @click="profile_edit = false">Save</button>
                    <button class="pro_btn cancel delete_btn" @click="profile_edit = false">Cancel</button>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab title="Staff">
            <div class="staff_tab">
              <div class="xv_table">
                <div class="xv_table_title">
                  <div>
                    <span>Staffs</span>
                  </div>
                  <div>
                    <div v-if="staff_edit == false">
                      <button class="pro_btn m_r sec_btn" @click="staff_edit = true">
                        <span class="mdi mdi-pencil"></span>
                      </button>
                    </div>

                    <div v-if="staff_edit == true">
                      <button class="pro_btn m_r save save_btn" @click="staff_edit = false">Save</button>
                      <button class="pro_btn cancel delete_btn" @click="staff_edit = false">Cancel</button>
                    </div>
                  </div>
                </div>

                <table class="hospital_staff_table">
                  <thead>
                    <tr>
                      <th style="width:15%">Type</th>
                      <th style="width:15%;text-align:center">Allocated</th>
                      <th style="width:15%;text-align:center">Available</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <span @click="update_marker()">Doctors</span>
                      </td>
                      <td>
                        <input type="number" value="8" :disabled="staff_edit == false" />
                      </td>
                      <td>
                        <input type="number" value="12" :disabled="staff_edit == false" />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span @click="update_marker()">Nurses</span>
                      </td>
                      <td>
                        <input type="number" value="5" :disabled="staff_edit == false" />
                      </td>
                      <td>
                        <input type="number" value="13" :disabled="staff_edit == false" />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span @click="update_marker()">Paramedical Staff</span>
                      </td>
                      <td>
                        <input type="number" value="14" :disabled="staff_edit == false" />
                      </td>
                      <td>
                        <input type="number" value="20" :disabled="staff_edit == false" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-tab>
          <b-tab title="Equipment ">
            <div class="equipment_tab">
              <div class="xv_table">
                <div class="xv_table_title">
                  <div>
                    <span>Equipment</span>
                  </div>
                  <div>
                    <div v-if="equipment_edit == false">
                      <button class="pro_btn m_r sec_btn" @click="equipment_edit = true">
                        <span class="mdi mdi-pencil"></span>
                      </button>
                    </div>

                    <div v-if="equipment_edit == true">
                      <button class="pro_btn m_r save save_btn" @click="equipment_edit = false">Save</button>
                      <button
                        class="pro_btn cancel delete_btn"
                        @click="equipment_edit = false"
                      >Cancel</button>
                    </div>
                  </div>
                </div>

                <table class="hospital_equipment_table">
                  <thead>
                    <tr>
                      <th style="width:15%">Type</th>
                      <th style="width:15%;text-align:center">Allocated</th>
                      <th style="width:15%;text-align:center">Available</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <span @click="update_marker()">Bed</span>
                      </td>
                      <td>
                        <input type="number" value="7" :disabled="equipment_edit == false" />
                      </td>
                      <td>
                        <input type="number" value="10" :disabled="equipment_edit == false" />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span @click="update_marker()">ICU</span>
                      </td>
                      <td>
                        <input type="number" value="5" :disabled="equipment_edit == false" />
                      </td>
                      <td>
                        <input type="number" value="12" :disabled="equipment_edit == false" />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span @click="update_marker()">Ventilators</span>
                      </td>
                      <td>
                        <input type="number" value="14" :disabled="equipment_edit == false" />
                      </td>
                      <td>
                        <input type="number" value="15" :disabled="equipment_edit == false" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-tab>
          <template v-slot:tabs-end></template>
        </b-tabs>
      </div>
    </div>
    <modal name="delete_popup" transition="pop-out" :width="450" height="auto">
      <deletePopup delete_text="Do you really want to delete this hospital? This cannot be undone."></deletePopup>
    </modal>
  </div>
</template>

<script>
import deletePopup from "../../../layout/delete_popup/delete_popup.vue";
export default {
  name: "Hospital_view_G",
  components: {
    deletePopup
  },
  data() {
    return {
      name: "",
      left_filter: false,
      profile_edit: false,
      staff_edit: false,
      equipment_edit: false,
      multiselect: null
    };
  },
  // watch: {
  //   "$route.params.id": function() {
  //     this.name = this.$route.params.id.slice(1);
  //   }
  // },
  created() {
    this.name = this.$route.params.id.slice(1);
  },
  methods: {
    delete_popup: function() {
      this.$modal.show("delete_popup");
    }
  }
};
</script>
